// src/config/menu.js
import {
    DashboardOutlined,
    UserOutlined,
    ShoppingCartOutlined,
    FileTextOutlined,
    DropboxOutlined,
    AlertOutlined,
    DesktopOutlined,
    GroupOutlined,
    DollarCircleOutlined,
    KeyOutlined,
    UsergroupAddOutlined,
    CloudOutlined,
    ProfileOutlined,
} from '@ant-design/icons';
import CustomIcon from '../../components/CustomView/CustomIcon';
import empy_img from '../../../assets/employe.png';
import invoice_project from '../../../assets/Invoice-wise-projects.png';
import hrm_icon from '../../../assets/hrm-icon.png';

export const MenuList = [
    { key: 'dashboard', icon: <DashboardOutlined />, label: 'Dashboard', to: '/dashboard' },
    
    {
        key: 'workspace_management',
        icon: <CustomIcon image={invoice_project} />,
        label: 'Manage Workspace',
        children: [
            { key: 'enquiry', label: 'Manage Enquiry', to: '/enquiry' },
            { key: 'Quotation', label: 'Manage Quotation', to: '/quotation' },
            { key: 'Invoice', label: 'Manage Invoice', to: '/invoice' },
            { key: 'Projects', label: 'Manage Projects', to: '/projects' },
            
            { key: 'view_invoice_project', label: 'Invoice-wise Projects', to: '/invoice-wise-projects' },
            // { key: 'manage-expense', label: 'Manage Expense', to: '/manage-expense' },
            { key: 'manage-vendor', label: 'Manage Vendor', to: '/manage-vendor' },
        ]
    },
    {
        key: 'finance',
        icon: <CustomIcon image={invoice_project} />,
        label: 'Finance',
        children: [
            { key: 'add vendor', label: 'Add Vendor', to: '/manage-vendor' },
            { key: 'po', label: 'Purchase Order', to: '/purchase-order' },
            { key: 'Project Expenses', label: 'Project Expenses', to: '/project-expenses' },
            { key: 'utilitybil', label: 'Utility Bills', to: '/utility-bills' },
            // { key: 'payments', label: 'Payments', to: '/payments'},
            // { key: 'Projects', label: 'Manage Projects', to: '/projects' },
            { key: 'reprots', label: 'Reports', to: '/finance/reports',
                children: [
            // { key: 'announcements', label: 'Announcements', to: '/announcements' },
            { key: 'P & L Report', label: 'P & L Report', to: '/finance/reports/p-l' },
            { key: 'Pay Mode Vise Reprt', label: 'Pay Mode Vise Reprt', to: '/finance/reports/pay-mode-vise' },
        ]
             },
         ]
    },
    {
        key: 'task_management',
        icon: <ProfileOutlined />,
        label: 'Task Management',

        children: [
            { key: 'managetask', label: 'Manage Project and Task', to: '/manage-task' },
            { key: 'assignedtask', label: 'Assigned Task', to: '/assigned-task' },
            { key: 'mytask', label: 'My Task', to: '/my-task' },
            { key: 'projecttimeline', label: 'Project TimeLine', to: '/project-timeline' },
        ]

        

    },
     {
        key: 'leave_raise',
        icon: <FileTextOutlined />, 
        label: 'Leave Raise',
        children: [
            { key: 'leave_request', label: 'Leave Request', to: '/leave-request' },
        ],
    },
    {
        key: 'user_management',
        icon: <UsergroupAddOutlined />,
        label: 'User Management',
        children: [
            { key: 'Manage_Organization', label: 'Manage Organization', to: '/manage-organization' },
            { key: 'Manage_user', label: 'Manage Users', to: '/manage-user' },
            { key: 'Manage_Permission', label: 'Manage Permission', to: '/manage-permission' },
        ]
    },
       { key: 'manage_empy_img', icon: <CustomIcon style={{ transform: "scale(1.2)", transformOrigin: "center center" }} image={empy_img} />, label: 'Manage Employees', to: '/manage-employees' },
    {
        key: 'compy_assets',
        icon: <DropboxOutlined />,
        label: 'Assets',
        children: [
            { key: 'Bank details', label: 'Manage Bank Details', to: '/manage-bank-data' },
            { key: 'Letter_Formats', label: 'Letter Formats', to: '/manage-letter-formats' },
        ]
    },
    {
        key: 'hrms',
        icon: <CustomIcon style={{ transform: "scale(1.2)", transformOrigin: "center center" }} image={hrm_icon} />,
        label: 'HRM Workspace',
        children: [
            // { key: 'announcements', label: 'Announcements', to: '/announcements' },
            { key: 'workforcemanagement', label: 'Workforce Management', to: '/workforce-management' },
        ]
    },

   

    

    { key: 'manage_services', icon: <CloudOutlined />, label: 'Manage Services', to: '/manage-services' },

];

